import { render, staticRenderFns } from "./additionalNavigationBlocks.vue?vue&type=template&id=4e476cec&"
import script from "./additionalNavigationBlocks.vue?vue&type=script&lang=js&"
export * from "./additionalNavigationBlocks.vue?vue&type=script&lang=js&"
import style0 from "./additionalNavigationBlocks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports